export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/MT-6465da94c46655e59c4025643e720768.png";